export const UPDATE_SESSION = 'UPDATE_SESSION';
export const UPDATE_LOADER = 'UPDATE_LOADER';
export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS';
export const UPDATE_BANNER = 'UPDATE_BANNER';
export const RESET_BANNER = 'RESET_BANNER';
export const SET_CHAT_INFO = 'SET_CHAT_INFO';
export const RESET_CHAT_INFO = 'RESET_CHAT_INFO';
export const SET_ENCRYPTION_FLAG = 'SET_ENCRYPTION_FLAG';
export const CURRENT_TAB = 'CURRENT_TAB';
export const UPDATE_CUSTOM_TRANSLATION = 'UPDATE_CUSTOM_TRANSLATION';
export const UPDATE_ERROR_LOGS = 'UPDATE_ERROR_LOGS';
export const UPDATE_ERROR_WEBHOOKS = 'UPDATE_ERROR_WEBHOOKS';
export const UPDATE_CONFIGURATIONS = 'UPDATE_CONFIGURATIONS';
